import { Box } from "@mui/material";
import React from "react";
import styles from "../../styles/pages/superadmin/message-details.module.scss";
// import styles from "../../styles/pages/mymessage.module.scss";
import Wrapper from "../../layout/wrapper/Wrapper";
import useFetch from "../../hooks/api/useFetch";
import { useParams } from "react-router-dom";
import MessageDetailsCard from "../../components/MessageDetailsCard/MessageDetailsCard";
import ApiLoader from "../../components/Loaders/ApiLoader";

const MessageDetails = () => {
    const { id } = useParams();
    const { data, isError, isLoading, isSuccess, refetch } = useFetch(
        "message-detail",
        `inquiry/${id}`
    );
    return (
        <Wrapper>
            <ApiLoader loading={isLoading && !data?.data?.data} />
            <Box className="main_body">
                <Box className={`commonBox ${styles.messageCommnBox}`}>
                    {isLoading && !data?.data?.data ? (
                        ""
                    ) : (
                        <MessageDetailsCard
                            message={data?.data?.data}
                            refetchMessageData={refetch}
                        />
                    )}
                </Box>
            </Box>
        </Wrapper>
    );
};

export default MessageDetails;
